// Central API configuration.
// `npm start` reads .env.development (local backend); production builds
// fall back to the deployed backend unless REACT_APP_API_URL is set.
export const API_URL = (
  process.env.REACT_APP_API_URL || "https://lrm-back.vercel.app/api/v1"
).replace(/\/+$/, "");

export const PRODUCTS_URL = `${API_URL}/products/`;

// Paystack PUBLIC key (safe to expose — it can only open the payment popup).
// Set REACT_APP_PAYSTACK_PUBLIC_KEY in .env.local to a pk_test_ key while
// testing so you don't charge real cards.
export const PAYSTACK_PUBLIC_KEY =
  process.env.REACT_APP_PAYSTACK_PUBLIC_KEY ||
  "pk_live_10aaf7ea3ec45f3aa0474aa97ba38a2e7781ea95";
